/**
 * Create the store with dynamic reducers
 */

import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { createLogger } from 'redux-logger';
import reduxThunk from 'redux-thunk';
import createReducer from './reducers';
import { createNotificationsMiddleware } from '@/containers/App/notificationsMiddleware';

export default function configureStore(initialState = {}, history, toast) {
  // Create the store with 3 middlewares
  // 1. routerMiddleware: Syncs the location/URL path to the state
  // 2. notificationsMiddleware: Handle notifications
  const middlewares = [reduxThunk, routerMiddleware(history), createNotificationsMiddleware(toast)];

  if (import.meta.env.NODE_ENV !== 'production') {
    middlewares.push(
      createLogger({
        collapsed: true,
      }),
    );
  }

  const enhancers = [applyMiddleware(...middlewares)];

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  const composeEnhancers =
    import.meta.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
      : compose;

  const store = createStore(createReducer(), initialState, composeEnhancers(...enhancers));

  // Extensions
  store.injectedReducers = {}; // Reducer registry

  return store;
}
